module.exports = __webpack_public_path__ + "static/img/choose_1_4.039f2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_1_4.png
// module id = e7U7
// module chunks = 0